import {
  Skeleton,
  SkeletonAvatar,
  SkeletonButton,
  SkeletonText,
} from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routeFor, routes } from 'src/core/constants/routes';
import history from 'src/core/history';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';

import { TravelPageWrapper } from '../../components/TravelPageWrapper/TravelPageWrapper';

export const BookingConfirmationPageSkeleton = () => {
  const { t } = useTranslation('global');
  const companyId = useCompanyId();

  const handleBack = () => {
    history.push(
      routeFor(routes.TRAVEL_SEARCH.path, {
        company: companyId,
      }),
    );
  };

  return (
    <TravelPageWrapper
      onBack={handleBack}
      title={t('travel.tripDetails.header.title')}
    >
      <div className="relative flex flex-1 gap-56 px-40 pt-24">
        <div className="flex flex-[2] flex-col gap-24 pb-32">
          <div className="box flex flex-col gap-8 p-8">
            <div className="flex items-center gap-8 p-8">
              <SkeletonText size="l" width="120px" />
            </div>
            <div className="bg-background-secondary-default rounded-8 p-16">
              <div className="flex items-center gap-8">
                <SkeletonAvatar size="s" />
                <SkeletonText size="l" width="200px" />
              </div>
            </div>
          </div>

          <div className="box flex flex-col gap-16 p-16">
            <div className="flex items-center gap-8">
              <SkeletonText size="l" width="160px" />
            </div>
            <div className="flex items-baseline justify-between gap-8">
              <div className="flex items-center gap-8">
                <Skeleton height="24px" width="80px" className="rounded-4" />
                <SkeletonText size="m" width="180px" />
              </div>
              <SkeletonText size="m" width="120px" />
            </div>
          </div>
        </div>

        <div className="box flex flex-1 flex-col gap-16 self-baseline overflow-hidden p-16">
          <SkeletonText size="l" width="150px" />

          <div className="flex flex-col gap-8">
            {[1, 2].map((index) => (
              <div
                key={index}
                className="flex items-center justify-between gap-4"
              >
                <div className="flex items-center gap-4">
                  <Skeleton height="16px" width="16px" />
                  <SkeletonText size="m" width="150px" />
                </div>
                <SkeletonText size="m" width="80px" className="text-right" />
              </div>
            ))}
          </div>

          <div className="separator" />

          <div className="flex items-baseline justify-between gap-4">
            <SkeletonText size="l" width="60px" />
            <SkeletonText size="xl" width="100px" className="text-right" />
          </div>

          <div className="flex flex-col items-end justify-end">
            <SkeletonButton width="100%" />
          </div>
        </div>
      </div>
    </TravelPageWrapper>
  );
};
